var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_has.js
// module id = Na1H
// module chunks = 11